import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const OvenIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "OvenIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.6841 2.44984H2.85596C2.53237 2.44984 2.27002 2.71218 2.27002 3.03578V21.8639C2.27002 22.1875 2.53236 22.4499 2.85596 22.4499H21.6841C22.0077 22.4499 22.2701 22.1875 22.2701 21.8639V3.03577C22.2701 2.71218 22.0077 2.44984 21.6841 2.44984ZM21.0982 21.278H3.4419V8.64254H4.78046V19.3535C4.78046 19.6771 5.0428 19.9394 5.3664 19.9394H19.1737C19.4973 19.9394 19.7597 19.6771 19.7597 19.3535V8.64254H21.0982V21.278ZM5.95234 18.7676V8.64255H18.5878V18.7676H5.95234ZM21.0982 7.47067H3.4419V3.62172H21.0982V7.47067Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.62158 6.13246C6.94519 6.13246 7.20752 5.87012 7.20752 5.54652C7.20752 5.22291 6.94519 4.96058 6.62158 4.96058C6.29798 4.96058 6.03564 5.22291 6.03564 5.54652C6.03564 5.87012 6.29798 6.13246 6.62158 6.13246Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.1528 6.13246C14.4764 6.13246 14.7388 5.87012 14.7388 5.54652C14.7388 5.22291 14.4764 4.96058 14.1528 4.96058C13.8292 4.96058 13.5669 5.22291 13.5669 5.54652C13.5669 5.87012 13.8292 6.13246 14.1528 6.13246Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.3872 6.13246C10.7108 6.13246 10.9731 5.87012 10.9731 5.54652C10.9731 5.22291 10.7108 4.96058 10.3872 4.96058C10.0636 4.96058 9.80127 5.22291 9.80127 5.54652C9.80127 5.87012 10.0636 6.13246 10.3872 6.13246Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9185 6.13246C18.2421 6.13246 18.5044 5.87012 18.5044 5.54652C18.5044 5.22291 18.2421 4.96058 17.9185 4.96058C17.5949 4.96058 17.3325 5.22291 17.3325 5.54652C17.3325 5.87012 17.5949 6.13246 17.9185 6.13246Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.6635 9.98108H7.87696C7.55337 9.98108 7.29102 10.2434 7.29102 10.567C7.29102 10.8906 7.55336 11.153 7.87696 11.153H16.6635C16.987 11.153 17.2494 10.8906 17.2494 10.567C17.2494 10.2434 16.9871 9.98108 16.6635 9.98108Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default OvenIcon;
